export const SIMILAR_ITEMS_SASH_PRODUCTS_COUNT = 8;
export const SIMILAR_ITEMS_SASH_PRODUCTS_CONDENSED_COUNT = 10;
export const MIN_PRODUCTS_PER_SEGMENT = 4;
export const YMAL_DESKTOP_PRODUCTS_PER_SEGMENT = 24;
export const YMAL_DESKTOP_PRODUCTS_PER_SEGMENT_VISIBLE_ON_PAGE = 12;
export const YMAL_MOBILE_PRODUCTS_PER_SEGMENT = 16;
export const YMAL_MOBILE_SEGMENT_ROWS = 2;
export const YMAL_DESKTOP_SEGMENT_ROWS = 4;
export const YMAL_PRODUCTS_TO_SEGMENT_COUNT = 150; // arbitrary high number so that we have enough recs to sort into segments
export const YMAL_DESKTOP_ITEMS_PER_ROW = 6;
export const SIMILAR_TO_SOLD_PRODUCTS_COUNT = 12;
export const SIMILAR_TO_SOLD_REQUIRED_PRODUCTS_COUNT = 6;
export const SIMILAR_TO_SOLD_FETCH_PRODUCTS_COUNT =
  SIMILAR_TO_SOLD_PRODUCTS_COUNT + 4;
export const SIMILAR_TO_SOLD_RECS_PER_PRODUCT = 3;
